import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const EMOJIS = ['😎', '🫠', '🕺', '💃', '🍻', '🔊', '💨', '😉', '😐', '😡', '😂', '💩', '👩', '❤️', '🥶', '🐭'];

function getRandomEmoji() {
  return EMOJIS[Math.floor(Math.random() * EMOJIS.length)];
}

function getNextPersonId(banya) {
  if (!banya || !banya.people || banya.people.length === 0) return 1;
  return Math.max(...banya.people.map(p => p.id)) + 1;
}

const useStore = create(
  persist(
    (set, get) => ({
      banya: null,

      startBanya: (startTime, endTime, hourlyRate, broomCost, name = '', date = '') => {
        const nextId = getNextPersonId(null);
        const newPerson = {
          id: nextId,
          name: 'Персона 1',
          emoji: getRandomEmoji(),
          arrivedAt: startTime,
          leftAt: endTime,
        };
        set({
          banya: {
            name,
            date,
            startTime,
            endTime,
            hourlyRate,
            broomCost,
            people: [newPerson],
          },
        });
      },

      updateBanyaSettings: (settings) => {
        const { banya } = get();
        if (!banya) return;
        set({ banya: { ...banya, ...settings } });
      },

      addPerson: () => {
        const { banya } = get();
        if (!banya) return;
        const { startTime, endTime } = banya;
        const nextId = getNextPersonId(banya);
        const newPerson = {
          id: nextId,
          name: `Персона ${banya.people.length + 1}`,
          emoji: getRandomEmoji(),
          arrivedAt: startTime,
          leftAt: endTime,
        };
        set({
          banya: {
            ...banya,
            people: [...banya.people, newPerson],
          },
        });
      },

      removePerson: (id) => {
        const { banya } = get();
        if (!banya || banya.people.length <= 1) return;
        set({
          banya: {
            ...banya,
            people: banya.people.filter((p) => p.id !== id),
          },
        });
      },

      updatePersonName: (id, name) => {
        const { banya } = get();
        if (!banya) return;
        set({
          banya: {
            ...banya,
            people: banya.people.map((p) =>
              p.id === id ? { ...p, name } : p
            ),
          },
        });
      },

      updatePersonEmoji: (id, emoji) => {
        const { banya } = get();
        if (!banya) return;
        set({
          banya: {
            ...banya,
            people: banya.people.map((p) =>
              p.id === id ? { ...p, emoji } : p
            ),
          },
        });
      },

      // Редактирование обоих времён сразу (не меняет статус "онбань/оффбань")
      updatePersonTimes: (id, arrivedAt, leftAt) => {
        const { banya } = get();
        if (!banya) return;
        set({
          banya: {
            ...banya,
            people: banya.people.map((p) =>
              p.id === id ? { ...p, arrivedAt, leftAt } : p
            ),
          },
        });
      },

      setPersonArrived: (id, time) => {
        const { banya } = get();
        if (!banya) return;
        set({
          banya: {
            ...banya,
            people: banya.people.map((p) =>
              p.id === id ? { ...p, arrivedAt: time } : p
            ),
          },
        });
      },

      setPersonLeft: (id, time) => {
        const { banya } = get();
        if (!banya) return;
        set({
          banya: {
            ...banya,
            people: banya.people.map((p) =>
              p.id === id ? { ...p, leftAt: time } : p
            ),
          },
        });
      },

      resetBanya: () => {
        set({ banya: null });
      },
    }),
    {
      name: 'banyaculator-storage',
    }
  )
);

export default useStore;
